import levelService from './levels.service';
import categorieService from './categories.service';
import eventService from './event.service';

export { levelService, categorieService, eventService };



// WEBPACK FOOTER //
// ./src/services/axios/index.js